import React, { useEffect, useState } from 'react'
import api from '../services/api'
import AdminMenu from '../components/AdminMenu'; // ajusta la ruta si estás en una subcarpeta


function AdminLogros() {
  const [logros, setLogros] = useState([])
  const [tipo, setTipo] = useState('')
  const [descripcion, setDescripcion] = useState('')
  const [puntos, setPuntos] = useState(0)

  useEffect(() => {
    api.get('/logros')
      .then(res => setLogros(res.data))
      .catch(err => console.error('Error al cargar logros', err))
  }, [])

  const crearLogro = () => {
    api.post('/logros', { tipo, descripcion, puntos })
      .then(() => {
        setTipo('')
        setDescripcion('')
        setPuntos(0)
        return api.get('/logros')
      })
      .then(res => setLogros(res.data))
      .catch(() => alert('Error al crear logro'))
  }

  return (
    <div>
      <h2>Gestión de Logros</h2>
      <input placeholder="Tipo" value={tipo} onChange={e => setTipo(e.target.value)} />
      <input placeholder="Descripción" value={descripcion} onChange={e => setDescripcion(e.target.value)} />
      <input type="number" placehozlder="Puntos" value={puntos} onChange={e => setPuntos(Number(e.target.value))} />
      <button onClick={crearLogro}>Crear</button>
      <ul>
        {logros.map(l => (
          <li key={l.id}>{l.tipo} - {l.descripcion} - {l.puntos} pts</li>
        ))}
      </ul>
    </div>
  )
}

export default AdminLogros
